import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getProductsFn = ({ search, page }) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.products}?search=${search}&page=${page}`);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const postProductTypeFn = (reqBody) => {
    try {
        const response = protectedApi.patch(ENDPOINTS.product_type, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}

export const postProductStatusFn = (reqBody) => {
    try {
        const response = protectedApi.post(ENDPOINTS.product_status, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message)
    }
}